// Note that the _value_ of a price can also be 'SP', but here
// we are defining the price _type_.
const PRICE_TYPES = {
    SP: 'SP',
    ODDS: 'Odds',
}

export default PRICE_TYPES



// WEBPACK FOOTER //
// /src/js/common/utils/priceTypes.js